var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div>\n  <div class=\"item header\"><span>{{ username }}</span><span class=\"headerTag\">{{ t(auth.role) }}</span></div>\n  <div ng-if=\"auth.roles.plannerPlus || auth.roles.clientPlus\" class=\"item\"><a href=\"https://support.di.no/support/tickets/new\" target=\"_blank\">{{ t('pageNewTicket') }}</a></div>\n  <div ng-if=\"auth.roles.plannerPlus || auth.roles.clientPlus\" class=\"item\"><a href=\"https://support.di.no/support/tickets\" target=\"_blank\">{{ t('pageViewTickets') }}</a></div>\n  <div class=\"item\"><a href=\"https://jira-di.atlassian.net/wiki/pages/viewpage.action?pageId=87228520\" target=\"_blank\">{{ t('pageDocumentation') }}</a></div>\n  <div class=\"item\"><a href=\"https://headwayapp.co/plan-go-release-notes\" target=\"_blank\">{{ t('pageChangeLog') }}</a></div>\n  <div class=\"item\"><a ng-click=\"logout()\">{{ t('pageLogout') }}</a></div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/helpMenu.jade
 ** module id = 84
 ** module chunks = 1
 **/